import React, { useState } from 'react'
import { ImportImage, Input, InputCheck } from 'src/components'
import { useFormContext } from 'react-hook-form'
import { cleanWeightValue, formatDateToInputValue, formatWeight, parseWeightToNumber } from 'src/utils'
import { TextArea } from 'src/components/TextArea'
import { useStyles } from './styles'
import { parseWeight } from '../../utils/functions'
import { AnimalRegistrationForm } from '../..'

interface AnimalBasicRegistrationProps {
  setAnimalImage: (image: File | null) => void
  handleSaveImage: (animalId: string) => Promise<void>
}

export const AnimalBasicRegistration: React.FC<AnimalBasicRegistrationProps> = ({
  setAnimalImage,
  handleSaveImage
}) => {
  const {
    register,
    watch,
    setValue,
    clearErrors,
    getValues,
    formState: { errors }
  } = useFormContext<AnimalRegistrationForm>()

  const formData = getValues()

  const [displayWeight, setDisplayWeight] = useState<string>(() => parseWeight(formData?.pesoAtual!))

  const styles = useStyles()

  return (
    <>
      <section className={styles.section}>
        <legend className={styles.sectionTitle}>Dados do animal</legend>
        <div className={styles.checkInputContainer}>
          <InputCheck
            id='sexo-male'
            value='M'
            label='Sexo macho'
            name='sexo_m'
            register={register}
            error={errors?.sexo?.message}
            checked={watch('sexo') === 'M'}
            onChange={(e) => {
              const value = e.target.value
              setValue('sexo', value)
              clearErrors('sexo')
            }}
          />
          <InputCheck
            id='sexo-female'
            value='F'
            register={register}
            label='Sexo fêmea'
            className={errors?.sexo?.message ? 'input-check--error' : ''}
            name='sexo_f'
            checked={watch('sexo') === 'F'}
            onChange={(e) => {
              const value = e.target.value
              setValue('sexo', value)
              clearErrors('sexo')
            }}
          />
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.container}>
            <Input
              label='Número'
              value={watch('cdn') || ''}
              error={errors?.cdn?.message}
              placeholder='Número'
              onChange={(value: string) => {
                setValue('cdn', value)
                clearErrors('cdn')
              }}
            />
            <Input
              id='data-nascimento'
              type='date'
              max='2999-12-31'
              label='Data de nascimento'
              error={errors?.dataNascimento?.message}
              onChange={(value: string) => {
                const date = new Date(value).toISOString()
                setValue('dataNascimento', date)
                clearErrors('dataNascimento')
              }}
              value={formatDateToInputValue(watch('dataNascimento') || '')}
            />
            <Input
              label='Peso'
              id='peso'
              className='input_text'
              value={displayWeight}
              error={errors?.pesoAtual?.message}
              placeholder='Quantos KG o animal tem?'
              onChange={(value: string) => {
                const cleanValue = cleanWeightValue(value)
                setDisplayWeight(cleanValue)
                clearErrors('pesoAtual')
              }}
              onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                const numericValue = cleanWeightValue(e.target.value)
                setDisplayWeight(numericValue)
              }}
              onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                const value = cleanWeightValue(e.target.value)

                const formattedValue = formatWeight(value)
                setDisplayWeight(formattedValue)

                const numericValue = parseWeightToNumber(value)
                setValue('pesoAtual', numericValue)
              }}
            />
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <legend className={styles.sectionTitle}>Detalhes</legend>
        <div>
          <TextArea
            label='Observações'
            id='observacoes'
            value={watch('observacoes') || ''}
            error={errors?.observacoes?.message}
            placeholder='Coloque suas observações aqui.'
            onChange={(value: string) => {
              setValue('observacoes', value)
            }}
          />

          <ImportImage
            onChange={async (image) => {
              setAnimalImage(image)
              const animalId = watch('idAnimal')
              if (animalId) {
                await handleSaveImage(animalId)
              }
            }}
          />
        </div>
      </section>
    </>
  )
}
